<template>
  <div class="template">
    <template v-if="templateType === 'addSizeChart'">
      <div class="box">
        <div class="title"><span class="star">*</span>尺码表模板 Size Chart Template</div>
        <div class="select">
          <el-select v-model="businessId" placeholder="请选择" size='mini' style="width:100%" @change="changeChart">
            <el-option
              v-for="item in sizeSpecDataList"
              :key="item.businessId"
              :label="item.name"
              :value="item.businessId"
            >
            </el-option>
          </el-select>
        </div>
        <div @click="createSizeChart">No optional size chart?
          <el-button type="text">Create a template</el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="box">
        <div class="title"><span class="star">*</span>模板名称 Template Name</div>
        <div class="select">
          <el-input
            v-model="templateName"
            type="text"
            placeholder="请输入内容"
            maxlength="250"
            show-word-limit
            size='mini'
          />
        </div>
      </div>
      <div class="box">
        <div class="title"><span class="star">*</span>尺码分类 Size Classification</div>
        <div class="select">
          <el-select v-model="class_id" placeholder="请选择" size='mini' style="width:100%">
            <el-option
              v-for="item in classCat"
              :key="item.classId"
              :label="item.className"
              :value="item.classId"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </template>
    <div v-if="(templateType === 'addSizeChart' && selChart.businessId) || templateType === 'temuTemplate'" class="box">
      <div class="title"><span class="star">*</span>尺码参数 size parameter</div>
      <el-checkbox-group v-model="checkSize" @change="changeCheck">
        <el-checkbox v-for="item in elements" :key="item.id" :label="item.id" :disabled="item.necessary">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
      <div class="size-list">
        <el-table ref="sizeTable" :data="sizeList" border max-height="400" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column
            v-if="templateType === 'temuTemplate'"
            fixed
            type="selection"
            width="50">
          </el-table-column>
          <el-table-column label="尺码" prop="1" width="100" fixed></el-table-column>
          <template v-for="item in paramColumn">
            <el-table-column :key="item.key" min-width="120">
              <template slot="header">
                <div class="title" style="margin-bottom:0;">{{ item.title }}</div>
              </template>
              <div slot-scope="{row}">
                <el-input
                  v-model.trim="row[item.key]"
                  :disabled="templateType === 'temuTemplate' && !multipleSelection.map(t => t[1]).includes(row[1])"
                  type="text"
                  placeholder="Please input"
                  show-word-limit
                  size='mini'
                  @input="e => handleInput(e, row, item.key)"
                />
              </div>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import TemplateTwo from '../../../index/album/components/TemplateTwo.vue'
import _ from 'lodash'
export default {
  components: { TemplateTwo },
  props: {
    templateType: {
      type: String,
      default: () => ''
    },
    // 尺码属性 （肩宽，衣长...）
    elementList: {
      type: Array,
      default: () => []
    },
    storeId: {
      type: [String, Number],
      default: () => ''
    },
    catId: {
      type: [String, Number],
      default: () => ''
    },
    // 选中的尺码size （XS, S, M, L...）
    checkSizeList: {
      type: Array,
      default: () => []
    },
    // 关闭弹窗初始化
    isShow: {
      type: Boolean,
      default: () => false
    },
    // 全部尺码 eur_size 欧码
    sizeAttr: {
      type: Object,
      default: () => {}
    },
    classId: {
      type: [String, Number],
      default: () => ''
    },
    className: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      templateName: '',
      class_id: this.classId,
      classCat: [{
        classId: this.classId,
        className: this.className
      }],
      elements: _.cloneDeep(this.elementList),
      checkSize: [],
      paramColumn: [],
      defaultParamColumn: [],
      sizeList: [],
      multipleSelection: [],
      sizeSpecDataList: [],
      businessId: '',
      selChart: {}
    }
  },
  watch: {
    isShow(value) {
      if (!value) {
        this.businessId = ''
        this.selChart = {}
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    createSizeChart() {
      this.$emit('createSizeChart')
    },
    initTemplate(type) {
      this.templateName = ''
      if (type !== 'edit') this.checkSize = this.elementList.filter(t => t.necessary).map(t => t.id)
      let paramColumn = []
      let defaultParamColumn = []
      this.elementList.forEach(t => {
        if (this.checkSize.includes(t.id)) {
          paramColumn.push({
            key: t.id,
            title: t.name,
            input: ''
          })
          if (t.necessary) {
            defaultParamColumn.push({
              key: t.id,
              title: t.name,
              input: ''
            })
          }
        }
      })
      this.paramColumn = paramColumn
      this.defaultParamColumn = _.cloneDeep(defaultParamColumn)
      if (type !== 'edit') {
        let checkSizeList = this.checkSizeList.map(t => t.value)
        let multipleSelection = []
        this.sizeList = this.sizeAttr.eur_size.map(item => {
          let obj = {
            1: item.value
          }
          this.checkSize.forEach(t => {
            obj[t] = ''
          })
          if (checkSizeList.includes(item.value)) {
            this.$nextTick(() => this.$refs.sizeTable.toggleRowSelection(obj))
          }
          return obj
        })
      }
    },
    temuGetSizeCharts(businessId, type) {
      API.temuGetSizeCharts({
        storeId: this.storeId,
        catId: this.catId,
        offset: 1,
        pageSize: 500
      }).then(res => {
        this.sizeSpecDataList = res.data.sizeSpecDataList
        // 创建尺码表后，默认选中刚创建的尺码表
        if (businessId && type === 'add') {
          this.businessId = businessId
          this.changeChart()
        }
      })
      // 查看尺码表
      if (businessId && type === 'edit') {
        this.temuGetNotReusableSizeCharts(businessId)
      }
    },
    // 查看尺码表
    temuGetNotReusableSizeCharts(id) {
      API.temuGetNotReusableSizeCharts({ businessIds: [id] }).then(res => {
        this.editSizeCharts = res.data
        this.selChart = res.data[0]
        this.checkSize = this.selChart.content.meta.elementList.map(t => t.id)
        this.initTemplate('edit')
        this.sizeList = this.selChart.content.records.map(t => ({ ...t.values }))
      })
    },
    // 切换模板
    changeChart() {
      this.sizeSpecDataList.forEach(item => {
        if (item.businessId === this.businessId) {
          this.selChart = item
          this.checkSize = item.contentDTO.meta.elements.map(t => t.id)

          // 表头
          let paramColumn = []
          let column = _.cloneDeep(item.contentDTO.records[0].values)
          delete column[1]
          for (let key in column) {
            let name = this.elements.filter(t => t.id === +key)
            paramColumn.push({
              key: key,
              title: (name && name.length) ? name[0].name : '',
              input: column[key]
            })
          }
          this.paramColumn = paramColumn

          // 表格数据
          let sizeList = []
          let sizeChartData = _.cloneDeep(item.contentDTO.records).map(t => ({ ...t.values }))
          this.checkSizeList.forEach(t => {
            let obj = { 1: t.value }
            let index = sizeChartData.findIndex(f => f[1] === t.value)
            this.paramColumn.forEach(k => {
              if (index > -1) {
                obj[k.key] = sizeChartData[index][k.key]
              } else {
                obj[k.key] = ''
              }
            })
            sizeList.push(obj)
          })
          this.sizeList = sizeList
        }
      })
    },
    // 切换尺码参数
    changeCheck() {
      let paramColumn = _.cloneDeep(this.defaultParamColumn)
      this.checkSize.forEach(t => {
        if (!this.defaultParamColumn.some(s => +s.key === t)) {
          let name = this.elements.filter(f => f.id === t)
          paramColumn.push({
            key: t,
            title: (name && name.length) ? name[0].name : ''
          })
        }
      })
      this.paramColumn = paramColumn
    },

    // 输入框只允许输入数字与一个小数点
    handleInput(e, row, key) {
      if (!+e && +e !== 0) {
        this.$set(row, key, e.replace(/[^\d]/g, '').replace(/^0{1,}/g, ''))
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style scoped lang="scss">
.template {
  .box {
    flex: 1;
    margin-bottom: 20px;
    .title {
      margin-bottom: 8px;
      .star {
        color: #f36d6f;
      }
    }
    .add {
      margin-top: 8px;
    }

    /deep/ .el-checkbox-group{
      display: flex;
      flex-wrap: wrap;
      .el-checkbox{
        display: flex;
        align-items: center;
        margin-right: 20px;
        margin-bottom: 8px;
        .el-checkbox__label {
          display: block;
          width: 125px;
        }
      }
    }
  }
}
</style>
